// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBZ4OiVFNn4rNJompapMCgOJGx_065iMdk",
  authDomain: "utgec-certificate.firebaseapp.com",
  projectId: "utgec-certificate",
  storageBucket: "utgec-certificate.firebasestorage.app",
  messagingSenderId: "413858653843",
  appId: "1:413858653843:web:1f613b232654bfd9a08f66",
  measurementId: "G-S495WB223P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { app, db, analytics, auth };
